// Values must match backend RoleNames (ExamFolio.Domain.Identity.RoleNames).
export const ROLE_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'Administrator', label: 'Administrator' },
  { value: 'QuestionAuthor', label: 'Question Author' },
  { value: 'Screener', label: 'Screener' },
  { value: 'Validator', label: 'Validator' },
  { value: 'Translator', label: 'Translator' },
  { value: 'CommitteeMember', label: 'Committee Member' },
  { value: 'LocationSupervisor', label: 'Location Supervisor' },
  { value: 'Candidate', label: 'Candidate' },
];

export function roleLabel(value: string): string {
  return ROLE_OPTIONS.find((r) => r.value === value)?.label ?? value;
}
